const getDefaultState = () => {
    return {
      token: localStorage.getItem('token') || '',
      user: localStorage.getItem('user') || null,
    };
  };

const state= getDefaultState();
const getters= {
    isLoggedIn: state => {
      return state.token;
    },
    getUser: state => {
      return state.user;
    }
  };
const mutations= {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      console.log('Setting up user in state: ', JSON.stringify(user));
      state.user = user;
    },
    RESET: state => {
      Object.assign(state, getDefaultState());
    }
  };
const actions= {
    logins: ({ commit }, {token, user} ) => {
      commit('SET_TOKEN', token);
      commit('SET_USER', user);
      // set auth header
      // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    logout: ({ commit }) => {
      commit('RESET', '');  
    }
  };
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };